<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar
        :back="true"
        title="Accounts"
        :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')"
      >
        <div class="options">
          <widgetSearch
            class="search-account"
            placeholder="Type in to Search..."
            icon="right"
            @keyup="searchContacts"
          ></widgetSearch>

          <div class="h-spacer"></div>

          <widgetDropdown
            v-model="display_input_filter"
            :right="true"
            :hover="false"
            :interactive="true"
          >
            <button class="btn-dropdown">
              Display
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a
                class="dropdown-item"
                href="#"
                v-for="(item, index) in display_filter"
                :key="index"
                @click="view_type = item.value"
              >
                {{ item.name }}</a
              >
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>

          <widgetDropdown
            v-model="tags_input_filter"
            :right="true"
            :hover="false"
            :interactive="true"
          >
            <button class="btn-dropdown">
              Tags
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <widgetListSelecter
                v-model="tags_filter"
                @close="tags_input_filter = false"
                @confirm="
                  (data) => {
                    tags_input_filter = false;
                    filterByTag(data);
                  }
                "
              ></widgetListSelecter>
            </div>
          </widgetDropdown>

          <div class="v-line-divider" style="height: 40px"></div>

          <widgetDropdown
            v-model="sort_input_filter"
            :right="true"
            :hover="false"
            :interactive="true"
          >
            <button class="btn-dropdown">
              Sort
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a
                class="dropdown-item"
                href="#"
                v-for="(item, index) in sort_filter"
                :key="index"
                @click="sort_filter_data = item.value"
              >
                {{ item.name }}</a
              >
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>

          <widgetButton
            style="width: 120px"
            @click="addNew()"
            :loading="false"
            class="btn-primary"
          >
            Add Contact +
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>
    <div class="page-tab">
      <div class="page-path-widget">
        <img
          @click="$router.push({ path: '/accounts' })"
          src="@/assets/icon/accounts-active.svg"
          class="icon"
        />
        <label
          @click="$router.push({ path: '/accounts' })"
          class="path-name link"
          >Accounts</label
        >
        <img src="@/assets/icon/outline-carret-green.svg" class="allow" />
        <label class="path-name" v-if="account"> {{ account.name }} </label>
      </div>

      <div class="page-tab-options row">
        <widgetButton
          :loading="false"
          @click="getStartData()"
          class="btn-transparent fit-content"
        >
          <img src="@/assets/icon/reflesh-gray.svg" />
        </widgetButton>
      </div>
    </div>
    <div class="page-body">
      <accountSidebar
        switch_tab="contacts"
        class="sidebar"
        :account="account"
      ></accountSidebar>
      <div v-if="account.contacts.length > 0" class="page-body-container">
        <div class="contacts-table" v-if="view_type == 'list'">
          <table class="table-data">
            <thead class="table-header">
              <tr>
                <th>Name</th>
                <th class="phone-hide">Email</th>
                <th class="phone-hide">Phone</th>
                <th class="phone-hide">Role</th>
                <th><div class="center">Action</div></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <template v-for="(item, index) in account.contacts">
                <tr :key="index">
                  <td @click="viewContact(item)">
                    <widgetProfile
                      :title="item.first_name + ' ' + item.last_name"
                      subtitle=""
                      file_name=""
                      path=""
                    ></widgetProfile>
                  </td>

                  <td class="phone-hide">
                    {{ item.email | validate }}
                  </td>
                  <td class="phone-hide">
                    {{ item.phone_alt | validate }}
                  </td>
                  <td>
                    <div
                      v-if="item.contact_type == 'company_contact'"
                      class="is-student-contact"
                    >
                      Assignment Contact
                    </div>
                    <div
                      v-if="item.contact_type == 'account_contact'"
                      class="is-account-contact"
                    >
                      Account Contact
                    </div>
                  </td>
                  <td>
                    <div class="menu">
                      <dropdownMenu>
                        <ul>
                          <li>
                            <a @click="updateContact(item)">Update</a>
                          </li>
                          <li>
                            <app-dialog
                              title="Delete Contact"
                              ask="Are you sure you want to delete this contact?"
                              yesText="Delete"
                              noText="Cancel"
                              @onComfirm="deleteContact(item.id)"
                            >
                              <a>Delete Contact</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdownMenu>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="contacts-items" v-else>
          <div
            class="contact-item"
            v-for="(item, index) in account.contacts"
            :key="index"
            @click="viewContact(item)"
          >
            <img src="@/assets/contact-avatar.svg" />
            <div class="contact-details-info">
              <h3>
                {{ (item.first_name + " " + item.last_name) | validate }}
              </h3>
              <h5>{{ item.title | validate }}</h5>
              <p class="email">{{ item.email | validate }}</p>
              <p class="phone">{{ item.phone_alt | validate }}</p>
            </div>
            <dropdown-menu class="menu">
              <ul>
                <li>
                  <a @click.prevent="updateContact(item)" href
                    >Update Contact</a
                  >
                </li>
                <li>
                  <app-dialog
                    title="Delete Contact"
                    ask="Are you sure you want to delete this contact?"
                    yesText="Delete"
                    noText="Cancel"
                    @onComfirm="deleteContact(item.id)"
                  >
                    <a>Delete Contact</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>
        <div class="contact-details" v-if="contact_details">
          <div class="contact-card">
            <img src="@/assets/contact-avatar.svg" />
            <h3>
              {{ contact_details.first_name | validate }} {{ " " }}
              {{ contact_details.last_name | validate }}
            </h3>
            <h5>{{ contact_details.title | validate }}</h5>
            <p>{{ contact_details.email | validate }}</p>
            <p>{{ contact_details.phone_alt | validate }}</p>
            <div class="tags">
              <div
                class="tag"
                v-for="(item, index) in contact_details.tags"
                :key="index"
              >
                {{ item.name | validate }}
              </div>
            </div>
            <p class="comment">{{ contact_details.comment | validate }}</p>

            <dropdown-menu class="menu">
              <ul>
                <li>
                  <a @click="updateContact(contact_details)">Update</a>
                </li>
                <li>
                  <app-dialog
                    title="Delete Contact"
                    ask="Are you sure you want to delete this contact?"
                    yesText="Delete"
                    noText="Cancel"
                    @onComfirm="deleteContact(contact_details.id)"
                  >
                    <a>Delete Contact</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>

          <div
            class="widget-container"
            v-if="contact_details.tasks && contact_details.tasks.length > 0"
          >
            <div class="container-header">
              <h3>Tasks</h3>
              <button
                class="btn-view-all"
                @click="$router.push({ name: 'task' })"
              >
                View All
              </button>
            </div>
            <div class="widget-body">
              <div
                v-for="(task, i) in contact_details.tasks.slice(0, 5)"
                :key="i"
                class="card"
              >
                <div class="card-header">
                  <div class="title">
                    {{ task.name | validate }}
                  </div>
                  <div class="card-type">
                    <label :style="{ color: getColor(task.type) }">{{
                      task.type | validate
                    }}</label>
                    <div
                      :style="{ 'background-color': getColor(task.type) }"
                      class="type-box"
                    ></div>
                  </div>
                </div>
                <div class="compang-widget">
                  <span class="company-name" v-if="task.account">{{
                    task.account.name | validate
                  }}</span>
                </div>
                <div class="members">
                  <div
                    class="member"
                    v-for="(member, index) in task.assignees"
                    :key="index"
                  >
                    <assingProfileToolTip :member="member">
                      <img
                        v-if="member.profile_picture"
                        :src="
                          $fullUrl('images/profiles/' + member.profile_picture)
                        "
                        :class="{ override: index > 0 }"
                      />
                      <img
                        v-else
                        :class="{ override: index > 0 }"
                        src="@/assets/avatar.png"
                      />
                    </assingProfileToolTip>
                    <span v-if="task.assignees.length == 1" class="name">{{
                      (member.first_name + " " + member.last_name) | validate
                    }}</span>
                  </div>
                </div>
                <div class="due-date" v-if="task.due_date">
                  {{
                    moment(task.due_date).format("ddd, DD MMM YYYY") | validate
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="widget-container"
            v-if="contact_details.leads && contact_details.leads.length > 0"
          >
            <div class="container-header">
              <h3>Leads</h3>
              <button
                class="btn-view-all"
                @click="$router.push({ name: 'leads' })"
              >
                View All
              </button>
            </div>
            <div class="widget-body">
              <div
                v-for="(lead, i) in contact_details.leads.slice(0, 5)"
                :key="i"
                class="lead-card"
              >
                <div class="card-header"></div>
                <div class="title-widget">
                  <span class="lead-name">{{ lead.name | validate }}</span>
                </div>
                <div class="compang-widget" v-if="lead.account">
                  <span class="company-name">
                    {{ lead.account.name | validate }}
                  </span>
                </div>

                <div class="members">
                  <div
                    class="member"
                    v-for="(member, index) in lead.assignees"
                    :key="index"
                  >
                    <assingProfileToolTip :member="member">
                      <img
                        v-if="member.profile_picture"
                        :src="
                          $fullUrl('images/profiles/' + member.profile_picture)
                        "
                        :class="{ override: index > 0 }"
                      />
                      <img
                        v-else
                        :class="{ override: index > 0 }"
                        src="@/assets/avatar.png"
                      />
                    </assingProfileToolTip>
                    <span v-if="lead.assignees.length == 1" class="name">{{
                      (member.first_name + " " + member.last_name) | validate
                    }}</span>
                  </div>
                </div>
                <div class="price">{{ lead.value | validate }} USD</div>
              </div>
            </div>
          </div>
          <div class="footer">
            <button class="btn-cancel" @click="contact_details = null">
              Close
            </button>
          </div>
        </div>
      </div>
      <div v-else class="page-body-container not-found-widget">
        <widgetNotFoundWidget
          title="Contacts not found"
          content="You can create a new contact by clicking on the button below."
          btntext="Create Contact"
          @click="addNew()"
        >
          <img
            class="widget-img"
            src="@/assets/admin-icon/student-search-icon.svg"
          />
        </widgetNotFoundWidget>
      </div>
    </div>

    <!-- Add - Update Modal -->
    <addUpdateContactModal
      v-if="show_form_add_update"
      :content="selected_contact"
      @success="contactSaved()"
      @close="show_form_add_update = false"
    ></addUpdateContactModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";
import addUpdateContactModal from "@/views/Accounts/components/add_update_contact_modal.vue";
export default {
  components: {
    accountSidebar,
    addUpdateContactModal,
  },
  data: () => ({
    selected_contact: null,
    sort_input_filter: false,
    tags_input_filter: false,
    display_input_filter: false,
    view_type: "list",
    sort_filter_data: "",
    display_filter: [
      {
        value: "grid",
        name: "Grid",
      },
      {
        value: "list",
        name: "List",
      },
    ],
    tags_filter: [],
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    task_types: [
      {
        name: "Task",
        color: "#0884AF",
      },
      {
        name: "Follow up",
        color: "#1BA5A4",
      },
      {
        name: "Call",
        color: "#FFC273",
      },
      {
        name: "Mail",
        color: "#9FD076",
      },
      {
        name: "Meeting",
        color: "#ACAF5C",
      },
      {
        name: "Other",
        color: "#ED6400",
      },
    ],
    show_form_add_update: false,
    show_view_contant_modal: false,
    adding_contact_loading: false,
    contacts_data: [],
    contact_details: null,
    account: {},
  }),
  mounted() {
    let vm = this;
    vm.getStartData();
    vm.getContactsTags();
  },
  methods: {
    getColor(val) {
      let vm = this;
      let color = "";
      vm.task_types.forEach((item) => {
        if (item.name == val) {
          color = item.color;
        }
      });
      return color;
    },
    getContactsTags() {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_GET_TAGS")
        .then((response) => {
          vm.tags_filter = response.data.map((item) => {
            return {
              value: item.name,
              name: item.name,
            };
          });
        })
        .catch((error) => {});
    },
    filterBySort(val) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_FILTER_BY_SORT", {
          option: val,
        })
        .then((response) => {
          vm.account.contacts = response.data;
        })
        .catch((error) => {});
    },
    filterByTag(val) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_FILTER_BY_TAG", {
          option: val,
        })
        .then((response) => {
          vm.account.contacts = response.data;
        })
        .catch((error) => {});
    },
    searchContacts({ target }) {
      let vm = this;
      vm.$store
        .dispatch("CONTACTS_SEARCH", {
          query: target.value,
        })
        .then((response) => {
          vm.account.contacts = response.data;
        })
        .catch((error) => {});
    },
    deleteContact(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_CONTACT_DELETE", { contact_id: id })
        .then((response) => {
          vm.getStartData();
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    viewContact(item) {
      let vm = this;
      vm.contact_details = item;
    },
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.account = responce.data;

          if (window.innerWidth > 500) {
            if (vm.account.contacts.length > 0) {
              vm.viewContact(vm.account.contacts[0]);
            }
          }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    contactSaved() {
      let vm = this;
      vm.selected_contact = null;
      vm.show_form_add_update = false;
      vm.getStartData();
    },
    addNew() {
      let vm = this;
      let obj = {};
      eventBus.$set(obj, "account", vm.account);
      vm.selected_contact = obj;
      vm.show_form_add_update = true;
    },
    updateContact(item) {
      let vm = this;
      eventBus.$set(item, "account", vm.account);
      vm.selected_contact = item;
      vm.show_form_add_update = true;
    },
  },
  watch: {
    sort_filter_data(val) {
      let vm = this;
      vm.filterBySort(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 10px;
  .page-header {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    .options {
      display: flex;
      align-items: center;
      .search-account {
        width: 250px;
      }
      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }
  .page-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    .page-path-widget {
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        margin-top: -10px;
        margin-right: 10px;
        cursor: pointer;
      }
      .allow {
        margin: 0px 10px;
      }
      .path-name {
        color: #1ba5a4;
        font-size: 15px;
        &.link {
          cursor: pointer;
        }
      }
    }
  }
  .page-body {
    height: calc(100% - 100px);
    border-radius: 5px;
    display: flex;
    .sidebar {
      width: 240px;
    }
    .page-body-container {
      height: 100%;
      width: calc(100% - 240px);
      display: flex;
      &.not-found-widget {
        background: #fff;
        border-radius: 5px;
        .widget-img {
          width: 120px !important;
        }
      }
      .contacts-table {
        padding: 10px;
        background: #fff;
        border-radius: 5px;
        height: 100%;
        width: calc(100% - 400px - 10px);
        overflow-y: auto;
      }
      .contacts-items {
        display: grid;
        grid-template-columns: 32.3333% 32.3333% 32.3333%;
        grid-gap: 10px;
        align-items: flex-start;
        &.list {
          display: block;
          height: 100%;
          overflow-y: auto;
          .contact-item {
            position: relative;
            background: #eeeeee;
            border-radius: 6px;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 8px;
            height: 50px;
            min-height: unset;
            margin-bottom: 10px;
            img {
              width: 30px;
              margin-bottom: 7px;
              margin-right: 10px;
            }
            .contact-details-info {
              display: flex;
              flex-direction: column;
              h3 {
                margin: 0px;
                font-size: 15px;
                margin-bottom: 0px;
              }
              h5 {
                margin: 0px;
                font-size: 15px;
                color: #646262;
                margin-bottom: 10px;
                display: none;
              }
              p.email {
                margin: 0px;
                font-size: 13px;
                color: #646262;
                display: none;
              }
              p.phone {
                margin: 0px;
                font-size: 13px;
                color: #646262;
              }
            }
            .menu {
              position: absolute;
              top: 15px;
              right: 10px;
            }
          }
        }
        .contact-item {
          position: relative;
          background: #eeeeee;
          border-radius: 6px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px;
          min-height: 200px;
          cursor: pointer;
          img {
            width: 80px;
            margin-bottom: 7px;
          }
          h3 {
            margin: 0px;
            font-size: 18px;
            margin-bottom: 4px;
          }
          h5 {
            margin: 0px;
            font-size: 15px;
            color: #646262;
            margin-bottom: 10px;
          }
          p {
            margin: 0px;
            font-size: 13px;
            color: #646262;
          }
          .menu {
            position: absolute;
            top: 8px;
            right: 10px;
          }
        }
      }
      .contact-details {
        padding-right: 10px;
        width: 400px;
        margin-left: 10px;
        height: 100%;
        overflow-y: auto;
        padding-bottom: 100px;
        background: #fff;
        border-radius: 10px;
        @media (min-width: 300px) and (max-width: 630px) {
          position: fixed;
          top: 0px;
          left: 0px;
          bottom: 0px;
          right: 0px;
          z-index: 999999;
          background: #fff;
        }
        .contact-card {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px 25px;
          margin-bottom: 10px;
          img {
            width: 80px;
            margin-bottom: 19px;
          }
          h3 {
            margin: 0px;
            font-size: 25px;
            margin-bottom: 4px;
          }
          h5 {
            margin: 0px;
            font-size: 14px;
            color: #646262;
            margin-bottom: 10px;
          }
          p {
            margin: 0px;
            font-size: 15px;
            margin-bottom: 10px;
            color: #646262;
          }
          p.comment {
            font-size: 14px;
            text-align: justify;
          }
          .menu {
            position: absolute;
            top: 20px;
            right: 10px;
          }
          .tags {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 10px;
            width: 100%;
            .tag {
              padding: 5px 10px;
              background: rgb(150, 150, 150);
              color: #fff;
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              margin-right: 8px;
              font-size: 11px;
              border-radius: 5px;
              .remove-btn {
                font-size: 14px;
                color: #fff;
              }
            }
          }
        }
        .widget-container {
          background: #ffffff;
          padding: 10px 10px;
          margin-bottom: 20px;
          border-radius: 5px;
          .container-header {
            display: flex;
            justify-content: space-between;
            padding: 15px 0px;
            h3 {
              font-size: 17px;
              margin: 0px;
            }
            .btn-view-all {
              color: #0884af;
            }
          }
          .widget-body {
            .card {
              width: 100%;
              background: #f5f5f5;
              position: relative;
              padding: 8px 8px;
              border-radius: 5px;
              margin-bottom: 5px;
              .card-header {
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;
                width: 100%;
                .title {
                  font-size: 14px;

                  color: #000;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 99%;
                }

                .card-type {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  label {
                    font-size: 10px;
                    white-space: nowrap;
                    text-align: right;
                  }
                  .type-box {
                    height: 15px;
                    width: 15px;
                    border-radius: 2px;
                    margin-left: 5px;
                  }
                }
              }
              .compang-widget {
                display: flex;
                flex-direction: column;
                padding-right: 20px;
                .company-name {
                  color: #707070;
                  font-size: 12px;
                  margin-bottom: 5px;
                }
                .company-contact {
                  display: flex;
                  align-items: center;
                  margin-bottom: 5px;
                  span {
                    font-size: 12px;
                    white-space: nowrap;
                  }
                  .other-contact {
                    color: #ccc;
                    font-size: 12px;
                    white-space: nowrap;
                  }
                }
              }
              .members {
                display: flex;
                .member {
                  display: flex;
                  align-items: center;
                  img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                    margin-right: 4px;
                    border-radius: 50%;
                    border: 2px solid #fff;
                    &.override {
                      margin-left: -10px;
                    }
                  }
                  .name {
                    background: #06a1a11f;
                    padding: 2px 5px;
                    border-radius: 15px;
                    font-size: 11px;
                    color: #04a5a5;
                    display: block;
                  }
                }
              }
              .due-date {
                position: absolute;
                bottom: 18px;
                right: 15px;
                font-size: 10px;
                display: none;
              }

              &.hold {
                border: solid#04a5a5 1px;
                border-radius: 5px;
              }
              &.invisible {
                opacity: 0.5;
              }
            }
            .lead-card {
              width: 100%;
              background: #f5f5f5;
              position: relative;
              padding: 15px 15px;
              cursor: pointer;
              border-radius: 5px;
              margin-bottom: 5px;
              &:hover {
                .card-header {
                  .card-checkbox {
                    display: block;
                  }
                }
              }
              .card-header {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                right: 2px;
                top: 8px;
                .card-checkbox:checked {
                  display: block;
                }
                .card-checkbox {
                  display: none;
                }
              }
              .title-widget {
                margin-bottom: 5px;
                .lead-name {
                  font-size: 14px;

                  color: #000;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 115px;
                }
              }
              .compang-widget {
                display: flex;
                justify-content: space-between;
                padding-right: 20px;
                .company-name {
                  color: #0884af;
                  font-size: 12px;
                }

                .company-contact {
                  display: flex;
                  align-items: center;
                  margin-bottom: 5px;
                  span {
                    font-size: 12px;
                    white-space: nowrap;
                  }
                  .other-contact {
                    color: #ccc;
                    font-size: 12px;
                    white-space: nowrap;
                  }
                }
              }

              .members {
                margin-top: 5px;
                display: flex;
                .member {
                  display: flex;
                  align-items: center;
                  img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                    margin-right: 4px;
                    border-radius: 50%;
                    border: 2px solid #fff;
                    &.override {
                      margin-left: -10px;
                    }
                  }
                  .name {
                    background: #06a1a11f;
                    padding: 2px 5px;
                    border-radius: 15px;
                    font-size: 11px;
                    color: #04a5a5;
                    display: block;
                  }
                }
              }
              .price {
                color: rgb(134, 134, 134);
                position: absolute;
                bottom: 18px;
                right: 15px;
                font-size: 10px;
              }
              .attachment {
                width: 100%;
                padding: 0px 10px;
                img {
                  width: 100%;
                  height: 70px;
                  object-fit: cover;
                  border-radius: 20px;
                }
              }
            }
          }
        }
        .footer {
          display: none;
          justify-content: center;
          padding: 30px;
          @media (min-width: 300px) and (max-width: 630px) {
            display: flex;
          }
          .btn-cancel {
            background: #24a5a5;
            height: 50px;
            width: 125px;
            color: #fff;
            outline: none;
            border: none;
            border-radius: 5px;
            margin-right: 15px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>
